import React, { useState } from 'react';
import './style.scss'
import { NumericFormat } from 'react-number-format';
import {
    EyeOutlined,
    EyeInvisibleOutlined
} from '@ant-design/icons';

const InputWithLabel = ({ requried, label, name, value, onChange, placeholder, inputFont, labelFont, onKeyDown, labelFontWeight, type, min, max, disabled, classes, error }) => {
    const [show, setShow] = useState(false);
    const getLabelStyles = () => {
        const styles = {};
        if (labelFont) {
            styles.fontSize = labelFont;
        }
        if (labelFontWeight) {
            styles.fontWeight = labelFontWeight;
        }
        return styles;
    }

    const inputType = type !== 'password' ? 
        type ?? 'text' :
        !show ? 'password' : 'text'

    return (
        <div className={`${classes ?? ''} input__with__label__main`}>
            <p style={getLabelStyles()}>
                {label}{requried && <span>*</span>}
            </p>
            {type === "number" ? <NumericFormat isAllowed={(values) => {
                const { floatValue } = values;
                return (
                    floatValue === undefined ||
                    ((min !== undefined ? floatValue >= min : true) &&
                        (max !== undefined ? floatValue <= max : true))
                );
            }} className='w-100' name={name} thousandSeparator decimalScale={0} value={value} onChange={(e) => { onChange({ target: { value: Number(e?.target?.value?.replaceAll(",", "")) } }); }} />
                : <input className={type === 'password' ? 'padding':''} disabled={disabled} type={inputType} onKeyDown={onKeyDown} style={inputFont ? { fontSize: inputFont } : {}} value={value} name={name} onChange={onChange} placeholder={placeholder} />}
            {type === 'password' ? <button className='password__eye__btn' onClick={()=> setShow(sh => !sh)}>{!show ? <EyeOutlined /> : <EyeInvisibleOutlined />}</button> : ""}
            {error ? <p className='error__text'>{error}</p>:""}
        </div>
    )
}

export default InputWithLabel